import { PaymentMethodType } from './hooks/use-deposit-payment-methods';
import { PaymentMethod } from './hooks/use-deposit-payment-methods';

export enum PaymentMethodTypes {
    PaysafePaypal = 'paysafe_paypal',
    PaysafeMazooma = 'paysafe_mazooma', // also known as Nuvei
    Paysafe = 'paysafe',
    Paysafe3ds = 'paysafe_3ds', // 3DS debit card payment. When it's available, it will be used preferentially.
    PaysafePayByBank = 'paysafe_pay_by_bank', // also known as Paysafe ACH
    PaysafeVenmo = 'paysafe_venmo',
    Trustly = 'trustly',
    FantasyMoney = 'fantasy_money',
    SocialWallet = 'social_wallet',
}

export const paymentMethodOrder: PaymentMethodType[] = [
    PaymentMethodTypes.Paysafe,
    PaymentMethodTypes.Paysafe3ds,
    PaymentMethodTypes.PaysafePayByBank,
    PaymentMethodTypes.PaysafePaypal,
    PaymentMethodTypes.PaysafeMazooma,
    PaymentMethodTypes.PaysafeVenmo,
    PaymentMethodTypes.Trustly,
    PaymentMethodTypes.FantasyMoney,
    PaymentMethodTypes.SocialWallet,
];

export const ccTypeMap: Record<string, string> = {
    VI: 'VISA',
    MC: 'Mastercard',
};

export const WALLET_GENERIC_ERROR_KEY = 'wallet.generic_error';

export const DEPOSIT_STATUS_UNIVERSAL_LINK_URL = 'https://link.betr.app/deposit-status';
export const DEPOSIT_STATUS_DEEP_LINK_URL = 'betrpickem://deposit-status';

// Mock FantasyMoney payment method
export const FANTASY_MONEY_PAYMENT_METHOD: PaymentMethod = {
    type: PaymentMethodTypes.FantasyMoney,
    value: 'fantasy_money',
    name: 'fantasy_money',
    supplier: 'betr',
    iframe: false,
    min: 10,
    max: 50000,
    logos: [],
    methods: {},
    accountId: '',
    order: 10,
};

export const SOCIAL_WALLET_PAYMENT_METHOD: PaymentMethod = {
    type: PaymentMethodTypes.SocialWallet,
    value: 'social_wallet',
    name: 'social_wallet',
    supplier: 'betr',
    iframe: false,
    min: 10,
    max: 50000,
    logos: [],
    methods: {},
    accountId: '',
    order: 11,
};
